import type { SyntheticEvent } from 'react';

// Swap a broken experiment image (e.g. a 404 Statsig URL) back to the bundled one; the guard stops an error loop
export const fallbackToImage = (defaultSrc: string) => (event: SyntheticEvent<HTMLImageElement>) => {
  const image = event.currentTarget;
  if (image.getAttribute('src') !== defaultSrc) image.src = defaultSrc;
};
